import PaperBase from '../../../../../Paper/PaperBase'
import GranularStepCard from '../../../../../card/GranularStepCard'
import { Tooltip } from '@mui/material'
import { DetailMarking } from '../../../../Assessment/Classes/MarkingClasses/DetailMarking/DetailMarking'
import {
  ContentTooltipMarkingInfo,
  useStyles
} from '../../../../Assessment/Classes/MarkingClasses/ContentTooltip/ContentTooltip'
import IconTooltipButton from '../../../../../button/IconTooltipButton'

const CardGranularStep = ({
  lcs = [],
  levelId,
  level,
  nextLevel,
  completed,
  marking,
  minMarking,
  onEvidenceOfLearning,
  onNote
}) => {
  const classes = useStyles()
  if (lcs.every((x) => x.granularSteps)) {
    let lcgs = []
    lcs.forEach((lc) => {
      const granularSteps = lc.granularSteps
        ?.filter((step) => step.levelId === levelId)
        .map((_, i) => String(i))
      lcgs = [...lcgs, ...granularSteps]
    })
    lcgs = [...new Set(lcgs)]

    const items = lcgs
    if (items.length > 0) {
      return items
        .map((item, index) => {
          const isLevel = index === 0
          if (!isLevel && !nextLevel) {
            return null
          }
          return (
            <div key={`granular-steps-${levelId}-gs-${index}`} className='flex flex-nowrap w-full gap-1'>
              <PaperBase
                backgroundColor={isLevel ? level.secondaryColor : 'var(--background)'}
                color={isLevel ? level.primaryColor : level?.secondaryColor}
                className='font-bold min-w-100px max-w-100px sticky left-0 z-10'
                outline={isLevel ? null : `1px solid ${level?.secondaryColor}`}
                children={isLevel ? `${level.name}` : `Working towards ${nextLevel?.name}`}
              />
              {lcs.map((lc, ilc) => {
                const gsslc = lc.granularSteps
                  ?.filter((step) => step.levelId === levelId)
                  ?.map((item) => ({
                    ...item,
                    position: parseInt(item.id.split('gs-')[1])
                  }))
                  ?.sort((a, b) => a.position - b.position)

                const find = gsslc[index]
                let findMarking = marking.find((item) => item._id === find?.[completed])
                if (!findMarking) {
                  findMarking = minMarking
                }

                const log = find?.logs?.find(
                  (log) =>
                    log.markingType === completed &&
                    log.exists &&
                    log.marking !== minMarking._id &&
                    log.definition
                )

                if (log) {
                  find.definition = (
                    <Tooltip
                      id={`granular-steps-${levelId}-gs-${item}-lc-${lc._id}-current-marking-${log._id}`}
                      arrow
                      placement='top'
                      title={
                        <div className='py-1'>
                          <ContentTooltipMarkingInfo marking={log} />
                        </div>
                      }
                      classes={{ tooltip: classes.customWidth }}
                    >
                      <span className='text-ellipsis text-sm cursor-pointer'>{find.definition}</span>
                    </Tooltip>
                  )
                }

                return (
                  <GranularStepCard
                    id={`granular-steps-${levelId}-gs-${item}-lc-${lc._id}-ul-${lc.ulId || 'main'}-class-${lc.classId || 'main'}-index-${ilc}`}
                    key={`granular-steps-${levelId}-gs-${item}-lc-${lc._id}-ul-${lc.ulId || 'main'}-class-${lc.classId || 'main'}-index-${ilc}`}
                    backgroundColor={find ? findMarking?.primaryColor : null}
                    color={find ? findMarking?.secondaryColor : null}
                    step={{ ...find }}
                    marking={
                      <DetailMarking
                        id={`granular-steps-${levelId}-gs-${item}-lc-${lc._id}`}
                        logs={find?.logs}
                        completed={completed}
                        minMarking={minMarking._id}
                      />
                    }
                    actionsEvidenceOfLearning={(evidence) => (
                      <>
                        <IconTooltipButton
                          title='Preview evidence of learning'
                          icon='expand-alt'
                          onClick={() =>
                            onEvidenceOfLearning({
                              ulId: lc.ulId,
                              classId: lc.classId,
                              levelId,
                              lcId: lc._id,
                              gsId: find?.id,
                              ...evidence
                            })
                          }
                          style={{
                            width: 24,
                            height: 24,
                            color: 'currentColor'
                          }}
                        />
                      </>
                    )}
                    actionsNote={(note) => (
                      <>
                        <IconTooltipButton
                          title='Preview note'
                          icon='expand-alt'
                          onClick={(e) => {
                            e.stopPropagation()
                            onNote({
                              ulId: lc.ulId,
                              classId: lc.classId,
                              levelId,
                              lcId: lc._id,
                              gsId: find?.id,
                              ...note
                            })
                          }}
                          style={{
                            width: 24,
                            height: 24,
                            color: 'currentColor'
                          }}
                        />
                      </>
                    )}
                  />
                )
              })}
            </div>
          )
        })
        .reverse()
    }
  }

  return []
}

export default CardGranularStep
